import React from 'react';
import { useNavigate } from 'react-router-dom';

function FilterCourses({ filterState, setFilterState, categories, path = '' }: { filterState: any; setFilterState: any; categories: any; path?: any }) {
	const navigate = useNavigate();
	return (
		<div className='block'>
			<div className='w-full flex flex-row justify-between mt-3'>
				<p className='text-left text-primaryViolet font-bold text-[18px] leading-6 '>Filter by categories</p>
				{path !== '' && (
					<button
						className='bg-[#ECEBF8] p-[10px] rounded-[10px] cursor-pointer text-primaryViolet font-bold text-[14px] hover:text-brandYellow hover:bg-primaryViolet ease-in-out duration-200 transition-all'
						onClick={() => {
							navigate(path);
						}}
					>
						Edit categories
					</button>
				)}
			</div>
			<div className='flex overflow-y-hidden overflow-x-auto w-full  pt-2 pb-5 my-1 items-center horizontal-grey-small-scroll '>
				<div
					className={`rounded-[10px] pointer text-sm p-[10px] font-semibold flex-1 flex items-center justify-center not-selectable text-nowrap   mr-[10px] ${
						filterState === '' ? 'bg-primaryViolet text-brandYellow' : 'bg-greyBackground hover:bg-greyLight text-primaryViolet'
					}`}
					onClick={() => setFilterState('')}
				>
					All
				</div>
				{categories?.map((item: any, index: number) => (
					<div
						className={`rounded-[10px] pointer text-sm p-[10px] font-semibold flex-1 flex items-center justify-center not-selectable text-nowrap   mr-[10px] ${
							filterState === item.id ? 'bg-primaryViolet text-brandYellow' : 'bg-greyBackground hover:bg-greyLight text-primaryViolet'
						}`}
						onClick={() => setFilterState(item.id)}
						key={index}
					>
						{item.name}
					</div>
				))}
			</div>
		</div>
	);
}

export default FilterCourses;
